module.exports = __webpack_public_path__ + "img/aspNetWebApi.4f7ba47a.svg";